define('UnitsOfMeasure.Helper', [
    'underscore',
    'SC.Configuration'
], function UnitsOfMeasureHelper(
    _,
    Configuration
) {
    'use strict';

    function safePropRead(obj, key) {
        if (obj && key) {
            if (_.isFunction(obj.get) && _.isObject(obj.attributes)) {
                return obj.get(key);
            }
            return obj[key];
        }
        return undefined;
    }

    return {
        showAnexPrice: function showAnexPrice(profile) {
            var enableLoyaltyField = _.findWhere(profile.get('customfields'), { name: 'custentity_loyalty_enabled' });
            var enableLoyalty = enableLoyaltyField && enableLoyaltyField.value === 'T';
            var isLoggedIn = profile.get('isLoggedIn') === 'T';
            var loyaltyPriceLevel = profile.get('priceLevel');
            return enableLoyalty && isLoggedIn && loyaltyPriceLevel;
        },
        resolvePriceAttribute: function resolvePriceAttribute(nsPriceLevel) {
            var mapping = Configuration.get('searchspring.priceLevelMapping', []);
            var value = _.findWhere(mapping, { netsuiteid: nsPriceLevel });
            return value && value.searchspringid;
        },
        getPriceLevelFormatted: function getPriceLevelFormatted(priceLevel, itemModel) {
            var priceAttr;
            var price = itemModel && itemModel.get('pricelevel' + priceLevel);
            if (!price) {
                priceAttr = this.resolvePriceAttribute(priceLevel);
                price = itemModel && itemModel.get(priceAttr) && parseFloat(itemModel.get(priceAttr)).toFixed(2);
            }
            return {
                price: price,
                priceFormatted: _.formatCurrency(parseFloat(price).toFixed(2))
            };
        },
        isPackItem: function isPackItem(itemInfo) {
            var saleUnitValue = safePropRead(itemInfo, 'saleunit');
            return saleUnitValue !== 'Unit';
        }
    };
});
